/**
 * SA-1034 PR 5 (spec §3.3): what the RAG badge says per store state. The
 * store starts `disconnected` and, before this PR, only the Settings page's
 * Test button ever moved it, so every session read "RAG: disconnected"
 * whatever RAG was doing. The idle word is "not checked" (ruling 4).
 */
import type { ConnectionStatus } from '@/stores/appStore'

export type RagStatusTone = 'neutral' | 'success' | 'destructive-soft'
export interface RagStatusWords { label: string; tip: string; tone: RagStatusTone }

const WORDS: Record<ConnectionStatus, RagStatusWords> = {
  disconnected: { label: 'RAG: not checked', tip: 'Checked when you send a message, or from Settings → Test connection', tone: 'neutral' },
  connecting: { label: 'RAG: connecting', tip: 'Testing the connection to the RAG server', tone: 'neutral' },
  connected: { label: 'RAG: connected', tip: 'The last message reached the RAG server', tone: 'success' },
  error: { label: 'RAG: error', tip: 'The last message to the RAG server failed. Try again, or test the connection in Settings.', tone: 'destructive-soft' },
}

export function ragStatusWords(status: ConnectionStatus): RagStatusWords {
  return WORDS[status]
}
